// extracted by mini-css-extract-plugin
export default {"messageInput":"lM_lN","messageInput_disabled":"lM_lO","messageInput__postfix":"lM_lP","messageInput__postfix_highlighted":"lM_lQ","messageInput__buttonLink":"lM_lR"};